import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { COLORS } from '../styles/tokens';

function playNotificationSound() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.frequency.setValueAtTime(880, ctx.currentTime);
    gain.gain.setValueAtTime(0.3, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.2);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.2);
  } catch {
    // Lydstøtte ikke tilgjengelig
  }
}

export default function NotificationToast({ notification, onDismiss }) {
  const navigate = useNavigate();
  const timerRef = useRef(null);

  useEffect(() => {
    if (!notification) return;

    playNotificationSound();
    if (navigator.vibrate) navigator.vibrate([200, 100, 200]);

    timerRef.current = setTimeout(() => onDismiss(), 6000);
    return () => clearTimeout(timerRef.current);
  }, [notification, onDismiss]);

  if (!notification) return null;

  function handleClick() {
    onDismiss();
    if (notification.orderId) navigate('/driver');
  }

  return (
    <div role="status" onClick={handleClick} style={styles.toast}>
      <div style={styles.icon} aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fdc149" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M2 6h11v10H2zM13 9h4l3 3v4h-7" /><circle cx="6" cy="17.5" r="1.8" /><circle cx="16.5" cy="17.5" r="1.8" />
        </svg>
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
          <span style={{ fontWeight: 700, fontSize: 13 }}>Tippi</span>
          <span style={{ fontSize: 12, color: COLORS.textLight }}>nå</span>
        </div>
        <div style={{ fontSize: 13, marginTop: 1 }}>
          <strong style={{ fontWeight: 600 }}>{notification.title}</strong>{notification.body ? ` ${notification.body}` : ''}
        </div>
      </div>
      <button
        onClick={(e) => { e.stopPropagation(); onDismiss(); }}
        style={{ background: 'none', border: 'none', color: COLORS.textLight, cursor: 'pointer', fontSize: 16, padding: 4 }}
        aria-label="Lukk"
      >
        ✕
      </button>
    </div>
  );
}

const styles = {
  toast: {
    position: 'fixed', top: 12, left: '50%', transform: 'translateX(-50%)', zIndex: 2000,
    background: COLORS.white, color: COLORS.textDark, borderRadius: 20, padding: '12px 14px',
    boxShadow: '0 6px 24px rgba(0,0,0,0.22)', display: 'flex', alignItems: 'center', gap: 12,
    cursor: 'pointer', maxWidth: 380, width: 'calc(100vw - 24px)',
  },
  icon: {
    width: 38, height: 38, borderRadius: 10, background: COLORS.primary, flexShrink: 0,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
};
